import { Course } from '../../services/courses/types';
import { SubjectColorKeys } from '../../theme';

import { SUBJECTS } from './constants';

export const getNameFromCourse = (courseCode: string, courses: Course[]) =>
  courses.find((course) => course.id === courseCode)?.label;

export const getShortNameFromCourse = (courseCode: string, courses: Course[]) =>
  courses.find((course) => course.id === courseCode)?.shortLabel;

export const getColorKeyFromCourse =
  (courseCode: string, courses: Course[]): SubjectColorKeys | undefined => {
    const course = courses.find((c) => c.id === courseCode);

    if (!course?.subject) return undefined;

    return SUBJECTS[course.subject]?.colorKey;
  };
